module.exports = __webpack_public_path__ + "static/img/cqcb.646c8ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bank/cqcb.png
// module id = r1vT
// module chunks = 93